import { useContext } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import DContext from '../../context/DContext';
import Icon from '../common/Icon';



const SideBar = () => {
    const location = useLocation();
    const navigate = useNavigate();

    const { authState, authDispatch, logout } = useContext(DContext);
    const { user, menu_access, deviceInfo } = authState;


    const getClassName = (activeMenu) => {
        let activeLink = location.pathname;
        if (activeLink === activeMenu) {
            return "nav-link"
        } else {
            return "nav-link collapsed"
        }
    }

    const handleLogout = () => {
        logout();
        authDispatch({ type: "LOGOUT" });
        navigate('/');
    }

    const toggleSidebar = () => {
        if (!document.body.classList.contains('toggle-sidebar') && window.innerWidth <= 1199) {
            document.body.classList.add("toggle-sidebar");
        } else {
            document.body.classList.remove("toggle-sidebar");
        }
    }

    const setModuleInfo = (module_id) => {
        localStorage.setItem('current_module_id', module_id)
    }

    // Shared active style: solid primary blue, white text (matches the front panel buttons)
    const activeItemStyle = {
        background: "var(--menu-active-bg)",
        color: "var(--menu-active-text)",
        boxShadow: "0 4px 12px rgba(14,106,150,0.25)",
    };

    const defaultItemStyle = {
        background: "transparent",
        color: "var(--menu-text)",
    };

    const hoverBg = "var(--menu-hover-bg)";
    const hoverText = "var(--menu-hover-text)";

    // Icons inherit the item text colour (white on the solid blue active item)
    const iconColor = () => "currentColor";

    return (
        <>
            <aside id="sidebar" className="sidebar"
                style={{
                    background: "var(--menu-bg)",
                    borderRight: "1px solid #d4e6f2",
                    boxShadow: "2px 0 16px rgba(14,106,150,0.06)"
                }}>
                <style>{`
                    #sidebar .sb-icon { margin: 0; transition: color .15s, transform .2s; }
                    #sidebar .sb-chevron { opacity: .6; }
                    #sidebar a:hover .sb-chevron { opacity: 1; }
                    #sidebar a:focus-visible { outline: 2px solid var(--btn-bg); outline-offset: -2px; }
                `}</style>

                <ul className="sidebar-nav" id="sidebar-nav" style={{ padding: "8px 12px" }}>

                    {/* Dashboard */}
                    <li className="nav-item">
                        <Link
                            to="/dashboard"
                            onClick={toggleSidebar}
                            className={getClassName("/dashboard")}
                            style={{
                                display: "flex", alignItems: "center", gap: "8px",
                                padding: "10px 12px", borderRadius: "10px", marginBottom: "2px",
                                fontSize: "13px", fontWeight: "600", textDecoration: "none",
                                transition: "all 0.15s",
                                ...(location.pathname === "/dashboard" ? activeItemStyle : defaultItemStyle)
                            }}
                            onMouseEnter={e => { if (location.pathname !== "/dashboard") { e.currentTarget.style.background = hoverBg; e.currentTarget.style.color = hoverText } }}
                            onMouseLeave={e => { if (location.pathname !== "/dashboard") { e.currentTarget.style.background = "transparent"; e.currentTarget.style.color = "var(--menu-text)" } }}
                        >
                            <Icon name="grid" size="md" color={iconColor(location.pathname === "/dashboard")} className="sb-icon" />
                            <span className="flex-grow-1">Dashboard</span>
                        </Link>
                    </li>

                    {/* Dynamic Menu */}
                    {menu_access?.map((user_menu, idx) => {
                        const isActive = user_menu?.subMenuAccess?.some(s => location.pathname === s?.route_to);
                        const isTopActive = location.pathname === user_menu?.route_to;

                        if (user_menu?.subMenuAccess?.length > 0) {
                            return (
                                <li className="nav-item" key={idx}>
                                    <Link
                                        className="nav-link collapsed d-flex align-items-center gap-2"
                                        data-bs-target={"#" + user_menu.slug}
                                        data-bs-toggle="collapse"
                                        to="#"
                                        onClick={() => setModuleInfo(user_menu?.module_id)}
                                        style={{
                                            padding: "10px 12px", borderRadius: "10px", marginBottom: "2px",
                                            fontSize: "13px", fontWeight: "600", textDecoration: "none",
                                            transition: "all 0.15s",
                                            background: isActive ? "var(--menu-active-bg)" : "transparent",
                                            color: isActive ? "var(--menu-active-text)" : "var(--menu-text)",
                                        }}
                                        onMouseEnter={e => { if (!isActive) { e.currentTarget.style.background = hoverBg; e.currentTarget.style.color = hoverText } }}
                                        onMouseLeave={e => { if (!isActive) { e.currentTarget.style.background = "transparent"; e.currentTarget.style.color = "var(--menu-text)" } }}
                                    >
                                        <Icon name={user_menu?.m_icon} size="md" color={iconColor(isActive)} className="sb-icon" />
                                        <span className="flex-grow-1">{user_menu?.name}</span>
                                        <Icon name="chevron-down" size="sm" className="sb-icon sb-chevron ms-auto" />
                                    </Link>

                                    <ul
                                        id={user_menu.slug}
                                        className="nav-content collapse"
                                        data-bs-parent="#sidebar-nav"
                                        style={{ paddingLeft: "0", listStyle: "none" }}
                                    >
                                        {user_menu?.subMenuAccess?.map((sub_menu, sidx) => {
                                            const subActive = location.pathname === sub_menu?.route_to;
                                            return (
                                                <li key={sidx} style={{ paddingLeft: "8px" }}>
                                                    <Link
                                                        to={sub_menu?.route_to}
                                                        onClick={toggleSidebar}
                                                        style={{
                                                            display: "flex", alignItems: "center", gap: "8px",
                                                            padding: "8px 12px 8px 14px", borderRadius: "8px", marginBottom: "2px",
                                                            fontSize: "12px", fontWeight: subActive ? "700" : "500",
                                                            textDecoration: "none", transition: "all 0.15s",
                                                            background: subActive ? "var(--menu-active-bg)" : "transparent",
                                                            color: subActive ? "var(--menu-active-text)" : "var(--menu-text)"
                                                        }}
                                                        onMouseEnter={e => { if (!subActive) { e.currentTarget.style.background = hoverBg; e.currentTarget.style.color = hoverText } }}
                                                        onMouseLeave={e => { if (!subActive) { e.currentTarget.style.background = "transparent"; e.currentTarget.style.color = "var(--menu-text)" } }}
                                                    >
                                                        <Icon name={sub_menu?.m_icon} size="sm" color={iconColor(subActive)} className="sb-icon" />
                                                        <span>{sub_menu?.name}</span>
                                                    </Link>
                                                </li>
                                            );
                                        })}
                                    </ul>
                                </li>
                            );
                        } else {
                            return (
                                <li className="nav-item" key={idx}>
                                    <Link
                                        to={user_menu?.route_to}
                                        onClick={() => setModuleInfo(user_menu?.module_id)}
                                        style={{
                                            display: "flex", alignItems: "center", gap: "8px",
                                            padding: "10px 12px", borderRadius: "10px", marginBottom: "2px",
                                            fontSize: "13px", fontWeight: "600", textDecoration: "none",
                                            transition: "all 0.15s",
                                            ...(isTopActive ? activeItemStyle : defaultItemStyle)
                                        }}
                                        onMouseEnter={e => { if (!isTopActive) { e.currentTarget.style.background = hoverBg; e.currentTarget.style.color = hoverText } }}
                                        onMouseLeave={e => { if (!isTopActive) { e.currentTarget.style.background = "transparent"; e.currentTarget.style.color = "var(--menu-text)" } }}
                                    >
                                        <Icon name={user_menu?.m_icon} size="md" color={iconColor(isTopActive)} className="sb-icon" />
                                        <span className="flex-grow-1">{user_menu?.name}</span>
                                    </Link>
                                </li>
                            );
                        }
                    })}
                </ul>
            </aside>
        </>
    )
}

export default SideBar
